import * as yup from 'yup'

{
  /* ひとまず英語にした sakao  */
}
export const emailSchema = yup
  .string()
  .email('valid_mail_address_warning')
  .required('mail_address_warning')
